import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M18.854.674A1.353 1.353 0 0 0 17.685 0H12.67v5.932h9.224ZM11.264 0H6.202a1.353 1.353 0 0 0-1.169.675L2.002 5.932h9.261V0ZM1.5 7.338v15.008A1.656 1.656 0 0 0 3.153 24h17.579a1.656 1.656 0 0 0 1.653-1.654V7.338Zm13.633 6.311-3.635 3.641a.7.7 0 0 1-.994 0l-1.7-1.706a.703.703 0 1 1 .994-.995l1.207 1.208 3.139-3.142a.703.703 0 1 1 .994.995Z" })
    ], -1)
  ])))
}
export default { render: render }